export const breakpoints = {
   lg: 1366,
   md: 992,
   sm: 768,
   xs: 480,
}
